import React, { useState } from 'react';
import classnames from 'classnames';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import '@style/Tab.scss';
import queryString from 'query-string';
import SimpleYoutube from '@molecules/slider/SimpleYoutube';
import { useMobxStores } from '@stores/store';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import i18n from 'i18next';
import LinkBtn from '@atoms/btn/LinkBtn';
import ShareBtn from '@atoms/btn/ShareBtn';

const MediaDetail = ({ type, src, title }) => {
  const { i18n } = useTranslation();
  const { t } = useTranslation();

  return (
    <div className="w-full h-full p-5 ">
      <p className="  pb-1 pr-10 text-left  font-TmoneyRoundWind">{title}</p>
      {type == 'image' && (
        <div>
          <img src={src} alt={title} />
        </div>
      )}
      {type == 'video' && (
        <div>
          <SimpleYoutube videoId={src} setOnPlay={false} onPlay={true} />
        </div>
      )}
      <div className="text-center items-center">
        <ShareBtn src={src} type={type} title={title} />
      </div>

      <div className={classnames('my-[55px]', 'xl:my-[80px]')}>
        <Link to={`/${i18n.language}/media`}>
          {<LinkBtn title={() => t('목록')} />}
        </Link>
      </div>
    </div>
  );
};

export default observer(MediaDetail);
